import { render, staticRenderFns } from "./VerificationTab.vue?vue&type=template&id=b384b798"
import script from "./VerificationTab.vue?vue&type=script&lang=js"
export * from "./VerificationTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports